import * as THREE from "three";


const calculateRealWrappedSize = (sectionWidthMM, engravingTarget) => {
	if (!engravingTarget) return sectionWidthMM;
	
	
	const bbox = new THREE.Box3().setFromObject(engravingTarget);
	const size = new THREE.Vector3();
	bbox.getSize(size);
	
	const diameter = Math.max(size.x, size.z);
	const radius = diameter / 2;
	
	const circumference = Math.PI * diameter;
	
	
	const angleFraction = sectionWidthMM / circumference;
	const angleRad = angleFraction * Math.PI * 2;

	return 2 * radius * Math.sin(angleRad / 2)
};



export default calculateRealWrappedSize